export enum CountByField {
	TYPE = 'TYPE',
	SUBTYPE = 'SUBTYPE',
	ORIG_PROBLEM_TYPE = 'ORIG_PROBLEM_TYPE',
	STATUS = 'STATUS',
	WARD = 'WARD',
	PRESSURE_ZONE = 'PRESSURE_ZONE',
	NEIGHBORHOOD = 'NEIGHBORHOOD'
}
